const ALLOWED_EMBED_HOSTS = new Set([
  'fast.wistia.net',
  'player.vimeo.com',
  'www.youtube-nocookie.com',
  'www.youtube.com',
  'youtube.com',
]);

export const toSafeEmbedUrl = (value: string | undefined): string | undefined => {
  if (!value) {
    return undefined;
  }

  let url: URL;

  try {
    url = new URL(value.trim());
  } catch {
    return undefined;
  }

  if (url.protocol !== 'https:' || !ALLOWED_EMBED_HOSTS.has(url.hostname)) {
    return undefined;
  }

  return url.toString();
};
